/**
 * Utilitário de Integração Dinâmica do Meta Pixel (Seguro contra falhas e exclusivo para PROD)
 */

const getFbq = () => {
  if (typeof window !== "undefined") {
    // Apenas carrega e injeta o SDK da Meta se estiver rodando em PRODUÇÃO ou se habilitado explicitamente em DEV
    const enableInDev = import.meta.env.VITE_ENABLE_META_PIXEL === 'true';
    if (!import.meta.env.PROD && !enableInDev) {
      return null;
    }

    if (window.fbq) return window.fbq;
    
    if (!window._fbq) {
      window._fbq = [];
      window.fbq = function() {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    return window.fbq;
  }
  return null;
};

export const MetaPixel = {
  // Inicializa o Pixel (Pode ser chamado múltiplas vezes com IDs diferentes)
  init: (pixelId, userData = {}) => {
    const enableInDev = import.meta.env.VITE_ENABLE_META_PIXEL === 'true';
    if (!import.meta.env.PROD && !enableInDev) {
      console.log(`[Meta Pixel DEV] Simulação de Init para o Pixel: ${pixelId}`, userData);
      return;
    }

    try {
      const fbq = getFbq();
      if (!pixelId || !fbq) return;

      const advancedMatching = {};
      if (userData.email) advancedMatching.em = userData.email.trim().toLowerCase();
      if (userData.phone) advancedMatching.ph = userData.phone.trim().replace(/\D/g, '');
      if (userData.name) {
        const parts = userData.name.trim().split(' ');
        advancedMatching.fn = parts[0].toLowerCase();
        if (parts.length > 1) advancedMatching.ln = parts[parts.length - 1].toLowerCase();
      }
      
      fbq('init', pixelId, advancedMatching);

      // Add noscript fallback img tag for verification tools
      if (typeof document !== "undefined" && document.body && !document.getElementById(`fb-noscript-${pixelId}`)) {
        const noscript = document.createElement('noscript');
        noscript.id = `fb-noscript-${pixelId}`;
        const img = document.createElement('img');
        img.height = '1';
        img.width = '1';
        if (img.style) {
          img.style.display = 'none';
        }
        img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
        noscript.appendChild(img);
        document.body.appendChild(noscript);
      }
    } catch (err) {
      console.error("Meta Pixel: Erro silencioso no init:", err);
    }
  },

  // Dispara eventos utilizando 'trackSingle' para isolamento por ID de Pixel
  track: (pixelId, eventName, customData = {}, options = {}) => {
    const enableInDev = import.meta.env.VITE_ENABLE_META_PIXEL === 'true';
    if (!import.meta.env.PROD && !enableInDev) {
      console.log(`[Meta Pixel DEV] Simulação de Evento [${eventName}] para o Pixel [${pixelId}]:`, customData);
      return;
    }

    try {
      const fbq = getFbq();
      if (!pixelId || !fbq) return;
      fbq('trackSingle', pixelId, eventName, customData, options);
    } catch (err) {
      console.error(`Meta Pixel: Erro silencioso ao disparar ${eventName}:`, err);
    }
  }
};
